export default "__VITE_ASSET__7b8cf7b0__"